<template>
    <div ref="chartdiv" :style="{ width: props.width, height: props.height }"></div>
</template>

<script setup>
import { onMounted, onUnmounted, ref, defineProps } from 'vue';
import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';

const chartdiv = ref(null);
const props = defineProps({ chartData: { default: null }, width: { default: '100%' }, height: { default: '100%' }, chartFontSizeData: { default: null } });
let root;
onMounted(() => {
    if (props.chartData && props.chartData.length > 0) {
        // console.log(props.chartData);
        root = am5.Root.new(chartdiv.value);

        // root.setThemes([am5themes_Animated.new(root)]);

        let chart = root.container.children.push(
            am5xy.XYChart.new(root, {
                // panX: false,
                // panY: false,
                // wheelX: "panX",
                // wheelY: "zoomX",
                paddingTop: 40,
                layout: root.verticalLayout,
            }),
        );

        // Define data
        let data = props.chartData;

        // Create Y-axis
        let yAxis = chart.yAxes.push(
            am5xy.ValueAxis.new(root, {
                // max: 110,
                // affectsMinMax: true,
                min: 0,
                max: 100,
                numberFormat: "#'%'",
                renderer: am5xy.AxisRendererY.new(root, { minGridDistance: 80 }),
            }),
        );

        // Create X-Axis
        let xAxis = chart.xAxes.push(
            am5xy.CategoryAxis.new(root, {
                renderer: am5xy.AxisRendererX.new(root, { minGridDistance: 10 }),
                categoryField: 'category',
                tooltip: am5.Tooltip.new(root, {}),
            }),
        );

        console.log('props.chartFontSizeData :', props.chartFontSizeData);
        xAxis.get('renderer').labels.template.setAll({
            // 2400px 넘는 경우 22px로 고정
            fontSize: props.chartFontSizeData ? props.chartFontSizeData.xAxis : '1.3vw',
            textAlign: 'center',
            fontWeight: 550,
            fill: '#222',
        });

        yAxis.get('renderer').labels.template.setAll({
            fontSize: props.chartFontSizeData ? props.chartFontSizeData.yAxis : '2.7vmin',
            fontWeight: 550,
            fill: '#222',
        });

        xAxis.data.setAll(data);

        // Create series
        let series1 = chart.series.push(
            am5xy.ColumnSeries.new(root, {
                name: 'Series',
                xAxis: xAxis,
                yAxis: yAxis,
                valueYField: 'value1',
                categoryXField: 'category',
                maskBullets: false,
                // tooltip: am5.Tooltip.new(root, {
                //     labelText: "{valueY}%",
                //     fill: am5.color(0xff5566)
                // }),
                fill: 'red',
            }),
        );

        series1.columns.template.setAll({
            fillOpacity: 0.5,
            strokeWidth: 2,
            width: 30,
            cornerRadiusTL: 30,
            cornerRadiusTR: 30,
        });

        let color = '#18b73f';
        series1.columns.template.adapters.add('fill', (fill, target) => {
            var value = target.dataItem.dataContext.value1;

            if (value < 50) {
                fill = '#A0A0A0';
            } else if (value >= 50 && value < 80) {
                fill = '#bee8c9';
            } else {
                fill = '#18b73f';
            }
            return fill;
        });

        series1.columns.template.adapters.add('stroke', (stroke, target) => {
            var value = target.dataItem.dataContext.value1;

            if (value < 50) {
                stroke = '#A0A0A0';
            } else if (value >= 50 && value < 80) {
                stroke = '#bee8c9';
            } else {
                stroke = '#18b73f';
            }
            return stroke;
        });

        series1.data.setAll(data);

        // let series2 = chart.series.push(
        //     am5xy.ColumnSeries.new(root, {
        //         name: "Series",
        //         xAxis: xAxis,
        //         yAxis: yAxis,
        //         valueYField: "value2",
        //         categoryXField: "category"
        //     })
        // );
        // series2.data.setAll(data);

        // Add legend
        // let legend = chart.children.push(am5.Legend.new(root, {}));
        // legend.data.setAll(chart.series.values);

        // Add cursor
        // chart.set('cursor', am5xy.XYCursor.new(root, {}));

        var tooltip = am5.Tooltip.new(root, {
            getFillFromSprite: false,
            getStrokeFromSprite: true,
            autoTextColor: false,
            getLabelFillFromSprite: true,
            labelText: '{valueY}%',
            fontSize: '1.2vmin',
        });

        tooltip.get('background').setAll({
            fill: 'white',
            fillOpacity: 0.8,
        });

        series1.set('tooltip', tooltip);
        // let activeState = polygonTemplate.states.create("active");
        // activeState.properties.fill = chart.colors.getIndex(4);

        // // Create an event to toggle "active" state
        // polygonTemplate.events.on("hit", function (ev) {
        //     ev.target.isActive = !ev.target.isActive;
        // })

        // Make stuff animate on load
        // Add Label bullet
        series1.bullets.push(function () {
            return am5.Bullet.new(root, {
                // locationY: 0.0,
                locationY: 1.0,
                sprite: am5.Label.new(root, {
                    text: "[fontWeight:700]{valueYWorking.formatNumber('#.')}%",
                    // fill: root.interfaceColors.get("alternativeText"),
                    centerY: am5.p100,
                    centerX: am5.p50,
                    populateText: true,
                    fill: 'black',
                    fontSize: props.chartFontSizeData ? props.chartFontSizeData.percentNum : '2.4vmin',
                }),
            });
        });

        series1.appear(2000);
        // series2.appear(1500);
        chart.appear(1000, 100);
    }
});

onUnmounted(() => {
    root.dispose();
});
</script>

<style scoped lang="scss"></style>
